const Post16Summary = (lang) => {
	const isRom = lang === 'rom'

	
	return {
		lang,
		cardTitle: isRom?  'Cutremur si poezie' :'Earthquake and poetry',	
		cardText:  isRom ?  'Povestesc aici cum un spectacol de poezie la care am fost m-a inspirat sa descriu experienta ingrozitorului cutremur din perspectiva tatalui meu si din perspectiva mea de copil mic care nu intelegea ce se intimpla.': 
		'I tell the story of how a poetry show I attended inspired me to write the experience of a terrible earthquake from the perspective of an adult, my father, as he later described it to me and my own, as a young child, blisfully unaware of what was going on.', 
		photoPath: '/post16/collage16l.jpg', 
		photoPathShort: '/post16/collage16s.jpg', 
		linkId: 'earthquake'
	}

}

export default Post16Summary;
